(function (Drupal, $) {

  $('#burger-menu, .header__sign-in').click(function () {
    $('html,body').addClass('sidebar--open');
    $('.layout__region--mobile-header').addClass('sidebar__open');
    $('header').addClass('fixed');
  });

  $('#burger-close-button').click(function () {
    $('html,body').removeClass('sidebar--open');
    $('.layout__region--mobile-header').removeClass('sidebar__open');
    $('header').removeClass('fixed');
  });

  $('.layout__region--mobile-header .dropdown-item--children').click(function () {
    var innerMenuHeight = $('.sidebar__content').outerHeight() + 'px';
    $(this).next().addClass('active').css('height', innerMenuHeight);
  });

  $('.layout__region--mobile-header .menu__back').click(function () {
    $(this).closest('.menu-dropdown').removeClass('active');
  });

  $(window).resize(function() {
    if ($('html,body').hasClass('sidebar--open')) {
      var innerMenuHeight = $('.sidebar__content').outerHeight() + 'px';
      $('.menu-dropdown-0').css('height', innerMenuHeight);
    }
  }).resize();

})(Drupal, jQuery);
